<template>
  <v-container class="content-box">
    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="user-application-info pb-16">
        <div class="mt-10 main-title">
          <slot>新規申請フォーム</slot>
        </div>
        <v-container class="pa-4 pb-10">
          <v-row class="mt-1">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="true"
                >認定証の種類</field-label-normal
              >
              <v-select
                :items="cert_codes"
                item-text="name"
                item-value="code"
                v-model="certificateForm.cert_code"
                dense
                outlined
                hide-details="auto"
                :rules="
                  showError.cert_code
                    ? showError.cert_code
                    : requiredSelectRules
                "
                placeholder="選択してください"
                @input="showError.cert_code = ''"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="mt-5">
            <v-col cols="12" sm="3" class="pt-0">
              <field-label-normal :requiredMark="true"
                >資格取得日</field-label-normal
              >
              <v-menu
                v-model="cert_regist_dateShow"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="certificateForm.cert_regist_date"
                    append-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    class="my-2 datepick text-field-calendar"
                    @click:append="cert_regist_dateShow = true"
                    :rules="
                      showError.cert_regist_date
                        ? showError.cert_regist_date
                        : requiredRules
                    "
                    @input="showError.cert_regist_date = ''"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="certificateForm.cert_regist_date"
                  @input="cert_regist_dateShow = false"
                  @change="setExpiredDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col cols="12" sm="3" class="pt-0">
              <field-label-normal :requiredMark="!expflg"
                >有効期間</field-label-normal
              >
              <v-menu
                v-model="cert_expire_dateShow"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="certificateForm.cert_expiry_date"
                    append-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :rules="
                      showError.cert_expiry_date
                        ? showError.cert_expiry_date
                        : requiredRules
                    "
                    @input="showError.cert_expiry_date = ''"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="certificateForm.cert_expire_date"
                  @input="cert_expire_dateShow = false"
                  :disabled="expflg"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="true"
                >支部名</field-label-normal
              >
              <v-select
                :items="branches"
                item-text="name"
                item-value="code"
                v-model="certificateForm.branch_code"
                dense
                outlined
                hide-details="auto"
                :rules="
                  showError.branch_code
                    ? showError.branch_code
                    : requiredSelectRules
                "
                placeholder="選択してください"
                @input="showError.branch_code = ''"
                @change="changeBranch"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="mt-5">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="true"
                >所属会社名</field-label-normal
              >
              <v-select
                :items="companies"
                item-text="company_name"
                item-value="id"
                v-model="certificateForm.company_name"
                dense
                outlined
                hide-details="auto"
                :rules="
                  showError.company_name
                    ? showError.company_name
                    : requiredRules
                "
                placeholder="選択してください"
                @input="showError.company_name = ''"
              >
              </v-select>
            </v-col>
          </v-row>
          <div class="mt-6">
            <field-label-normal :requiredMark="true">氏名</field-label-normal>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="certificateForm.cert_name"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.cert_name ? showError.cert_name : certNameRules
                  "
                  @input="showError.cert_name = ''"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="mt-6">
            <field-label-normal :requiredMark="true"
              >氏名カナ</field-label-normal
            >
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="certificateForm.cert_kana_name"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.cert_kana_name
                      ? showError.cert_kana_name
                      : certNameKanaRules
                  "
                  @input="showError.cert_kana_name = ''"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="mt-6 error-message">
            <field-label-normal :requiredMark="true"
              >自宅 住所</field-label-normal
            >
            <v-form ref="zipcodeForm" v-model="zipcodeValid" lazy-validation>
              <div class="text-sub-title pb-3">郵便番号</div>
              <div class="d-flex mx-n3 my-n1">
                <v-col cols="5" sm="2" class="pr-0 pt-0">
                  <v-text-field
                    type="tel"
                    v-model="certificateForm.zipCdPart1"
                    dense
                    outlined
                    hide-details="auto"
                    class="zipcode1-text-field"
                    :rules="
                      showError.zipCdPart1
                        ? showError.zipCdPart1
                        : [zipcodeFullValidation].concat(requiredRules)
                    "
                    @change="validateZipcode"
                    @input="
                      showError.zipCdPart1 = '';
                      validateZipcode;
                    "
                  >
                    <div slot="append-outer">―</div>
                  </v-text-field>
                </v-col>
                <v-col cols="4" sm="2" class="pr-0 pt-0">
                  <v-text-field
                    type="tel"
                    v-model="certificateForm.zipCdPart2"
                    dense
                    outlined
                    hide-details="auto"
                    class="zipcode2-text-field"
                    :rules="
                      showError.zipCdPart2
                        ? showError.zipCdPart2
                        : [zipcodeFullValidation].concat(requiredRules)
                    "
                    @change="validateZipcode"
                    @input="
                      showError.zipCdPart2 = '';
                      validateZipcode;
                    "
                  ></v-text-field>
                </v-col>
              </div>
            </v-form>
          </div>
          <div class="mt-2 error-message">
            <v-row>
              <v-col cols="12" sm="4" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">都道府県</div>
                <v-select
                  :items="prefectures"
                  v-model="certpref"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.cert_prefectures
                      ? showError.cert_prefectures
                      : requiredSelectRules
                  "
                  placeholder="選択してください"
                  @input="showError.cert_prefectures = ''"
                ></v-select>
              </v-col>
            </v-row>
          </div>
          <div class="mt-2 error-message">
            <v-row>
              <v-col cols="12" sm="8" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">住所</div>
                <v-text-field
                  v-model="certadd"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.cert_address1
                      ? showError.cert_address1
                      : address1Rules
                  "
                  @input="showError.cert_address1 = ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="mt-2 error-message">
            <v-row>
              <v-col cols="12" sm="8" class="pt-0">
                <div class="text-sub-title mt-5 pb-2">マンション名</div>
                <v-text-field
                  v-model="certificateForm.cert_address2"
                  dense
                  outlined
                  hide-details="auto"
                  :rules="
                    showError.cert_address2
                      ? showError.cert_address2
                      : address2Rules
                  "
                  @input="showError.cert_address2 = ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row class="mt-2">
            <v-col cols="12" sm="5">
              <field-label-normal>電話番号</field-label-normal>
              <v-text-field
                type="tel"
                v-model="certificateForm.tel"
                dense
                outlined
                hide-details="auto"
                :rules="showError.tel ? showError.tel : telRules"
                @input="showError.tel = ''"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="true"
                >メールアドレス</field-label-normal
              >
              <v-text-field
                v-model="certificateForm.email"
                dense
                outlined
                hide-details="auto"
                :rules="showError.email ? showError.email : emailRules"
                @input="showError.email = ''"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="3">
              <field-label-normal :requiredMark="true"
                >生年月日</field-label-normal
              >
              <v-menu
                v-model="birthDateShow"
                ref="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="certificateForm.birthday"
                    append-icon="mdi-calendar"
                    class="datepick"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click:append="birthDateShow = true"
                    :rules="
                      showError.birthday ? showError.birthday : requiredRules
                    "
                    @input="showError.birthday = ''"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="certificateForm.birthday"
                  :show-current="show_brith_date"
                  @input="birthDateShow = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <div
            @drop="dropThumb($event)"
            @dragenter="startDrop($event)"
            @dragleave="endDrop($event)"
            @dragover.prevent
          >
            <field-label-normal :requiredMark="true"
              >顔写真アップロード</field-label-normal
            >
            <field-label-normal class="pb-2"
              >※ 3ヶ月以内の顔写真（ jpeg形式、3MB以内
              ）を添付してください。</field-label-normal
            >
            <v-row class="image_up">
              <div v-show="image_preview_show_1" class="mt-3 ml-3">
                <div
                  class="imagePreviewWrapper"
                  :style="{ 'background-image': `url(${previewImage_1})` }"
                  @click="selectImage"
                ></div>
              </div>
              <div class="col-sm-6">
                <v-card
                  class="vcard-upload"
                  :class="dragging ? 'dropZone-over' : ''"
                  @dragover="_ondragover($event)"
                  @drop="_ondrop($event)"
                  @dragleave="_ondragleave($event)"
                  @dragenter="_ondragenter($event)"
                  height="132px"
                  outlined
                >
                  <div
                    class="after-pickup-title1 px-1"
                    :class="after_image_upload ? 'pickup1-mobile' : ''"
                  >
                    ファイルをドラッグ＆ドロップしてください
                  </div>
                  <div
                    class="after-pickup-title2"
                    :class="after_image_upload ? 'pickup2-mobile' : ''"
                  >
                    または
                    <v-btn
                      depressed
                      class="btn-pickup-margin"
                      :class="after_image_upload ? 'pickup-button' : ''"
                      height="35"
                      @click="selectImageClick"
                      >ファイルを選択</v-btn
                    >
                  </div>
                  <input
                    ref="uploader_img"
                    :src="certificateForm.appli_image"
                    class="d-none"
                    type="file"
                    accept="image/jpeg"
                    @change="imgOnFileChanged"
                    @input="showError.appli_image = ''"
                  />
                </v-card>
              </div>
            </v-row>
            <v-card-text v-if="showError.appli_image" class="error--text">
              {{ showError.appli_image[0] }}
            </v-card-text>
          </div>
          <div class="col-sm-8 mt-0 pb-0" v-show="after_image_upload">
            <v-container>
              <v-row style="align-items: baseline">
                <v-col cols="8" sm="7">
                  <div class="uploaded-data-title col-sm-12">ファイル名</div>
                </v-col>
                <v-col cols="4" sm="5" class="d-flex">
                  <div class="col-sm-8 sizepos" style="align-items: end">
                    サイズ
                  </div>
                  <div class="col-sm-4 pc-size"></div>
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-divider class="info-line-driver border-0"></v-divider>
              </v-row>
              <v-row style="align-items: baseline">
                <v-col cols="8" sm="7">
                  <div class="uploaded-data-title truncate pl-3">
                    {{ upload_image_file_name }}
                  </div>
                </v-col>
                <v-col cols="4" sm="5" class="d-flex py-2 justify-left">
                  <div class="py-2 col-sm-8 sizepos">
                    {{ upload_image_file_size }}
                  </div>
                  <v-btn
                    @click="deleteUploadImage"
                    class="col-sm-4 delete-icon py-2"
                    text
                    icon
                    color="black"
                  >
                    <svg-icon
                      iconClass="Icon feather-trash-2"
                      class="trash-icon"
                    />
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <v-row class="mt-3">
            <v-col cols="12" sm="6">
              <field-label-normal :requiredMark="true"
                >認定証送付先</field-label-normal
              >
              <v-select
                :items="certificate_destination"
                item-text="name"
                item-value="code"
                v-model="certificateForm.deli_code"
                dense
                outlined
                hide-details="auto"
                :rules="
                  showError.deli_code
                    ? showError.deli_code
                    : requiredSelectRules
                "
                placeholder="選択してください"
                @input="showError.deli_code = ''"
              >
              </v-select>
            </v-col>
          </v-row>
          <div v-show="certificateForm.deli_code == delicode.OTHER">
            <div class="mt-6 error-message">
              <field-label-normal :requiredMark="true"
                >送付先住所</field-label-normal
              >
              <v-form
                ref="delizipcodeForm"
                v-model="deliZipcodeValid"
                lazy-validation
              >
                <div class="text-sub-title pb-3">郵便番号</div>
                <div class="d-flex mx-n3 my-n1">
                  <v-col cols="5" sm="2" class="pr-0 pt-0">
                    <v-text-field
                      type="tel"
                      v-model="certificateForm.deli_zipCdPart1"
                      dense
                      outlined
                      hide-details="auto"
                      :rules="
                        showError.deli_zipCdPart1
                          ? showError.deli_zipCdPart1
                          : certificateForm.deli_code == delicode.OTHER
                          ? [deliZipcodeFullValidation]
                          : []
                      "
                      @change="deliValidateZipcode"
                      @input="
                        showError.deli_zipCdPart1 = '';
                        deliValidateZipcode;
                      "
                    >
                      <div slot="append-outer">―</div>
                    </v-text-field>
                  </v-col>
                  <v-col cols="4" sm="2" class="pr-0 pt-0">
                    <v-text-field
                      type="tel"
                      v-model="certificateForm.deli_zipCdPart2"
                      dense
                      outlined
                      hide-details="auto"
                      :rules="
                        showError.deli_zipCdPart2
                          ? showError.deli_zipCdPart2
                          : certificateForm.deli_code == delicode.OTHER
                          ? [deliZipcodeFullValidation]
                          : []
                      "
                      @change="deliValidateZipcode"
                      @input="
                        showError.deli_zipCdPart2 = '';
                        deliValidateZipcode;
                      "
                    >
                    </v-text-field>
                  </v-col>
                </div>
              </v-form>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="4" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">都道府県</div>
                  <v-select
                    :items="prefectures"
                    v-model="delipref"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="
                      showError.deli_prefectures
                        ? showError.deli_prefectures
                        : certificateForm.deli_code == delicode.OTHER
                        ? requiredSelectRules
                        : []
                    "
                    placeholder="選択してください"
                    @input="showError.deli_prefectures = ''"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="8" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">住所</div>
                  <v-text-field
                    v-model="deliadd"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="
                      showError.deli_address1
                        ? showError.deli_address1
                        : certificateForm.deli_code == delicode.OTHER
                        ? address1Rules
                        : []
                    "
                    @input="showError.deli_address1 = ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="8" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">マンション名</div>
                  <v-text-field
                    v-model="certificateForm.deli_address2"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="
                      showError.deli_address2
                        ? showError.deli_address2
                        : address2Rules
                    "
                    @input="showError.deli_address2 = ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2 error-message">
              <v-row>
                <v-col cols="12" sm="5" class="pt-0">
                  <div class="text-sub-title mt-5 pb-2">
                    <field-label-normal>電話番号</field-label-normal>
                  </div>
                  <v-text-field
                    type="tel"
                    v-model="certificateForm.deli_tel"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="
                      showError.deli_tel
                        ? showError.deli_tel
                        : certificateForm.deli_code == delicode.OTHER
                        ? telRules2
                        : []
                    "
                    @input="showError.deli_tel = ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-row class="mt-3">
            <v-col cols="12" sm="8">
              <field-label-normal
                ><span>技能士（防水施工&nbsp;&nbsp;&nbsp;アクリルゴム系塗膜防水工事作業）</span></field-label-normal
              >
              <v-radio-group v-model="certificateForm.national_cert1" row>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="1"
                  label="１級"
                  :value="1"
                ></v-radio>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="2"
                  label="２級"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" sm="8">
              <field-label-normal>建築施工管理技士</field-label-normal>
              <v-radio-group v-model="certificateForm.national_cert2" row>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="1"
                  label="１級"
                  :value="1"
                ></v-radio>
                <v-radio
                  class="nationalcertradio pa-0"
                  :key="2"
                  label="２級"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="8">
              <field-label-normal>備考</field-label-normal>
              <v-textarea
                v-model="certificateForm.description"
                outlined
                class="no-radius"
                :rules="
                  showError.description
                    ? showError.description
                    : descriptionRules
                "
                @input="showError.description = ''"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <div class="mt-2">
            <v-row class="btn-area ml-0">
              <v-btn
                large
                class="btn-margin btn-text"
                height="40"
                width="200"
                @click.once="add"
                :key="buttonKey"
                >申請 + 承認</v-btn
              >
            </v-row>
          </div>
        </v-container>
      </div>
    </v-form>
    <!-- <v-row class="punks-area mb-13">
      <span class="punks-textpointer">新規申請フォーム</span>
      <span class="ml-1 mt-n2"
        ><svg-icon class="arrow-icon" iconClass="Icon ionic-ios-arrow-forward"
      /></span>
    </v-row> -->
  </v-container>
</template>

<script>
import FieldLabelNormal from "@/components/FormElements/FieldLabelNormal";
import { CERTDEST } from "@/utils/mst-cert-dest";
import { USERTAB } from "@/utils/mst-user";
import { getBranch, getCert, getRequest, getCompany } from "@/api/common";
import { addCertificate } from "@/api/certificate";
import { PREFS } from "@/utils/mst-prefectures";
import validations from "@/utils/common-validation";
import { Core as YubinBangoCore } from "yubinbango-core";
import moment from 'moment';
import { DELICODE } from "@/utils/mst-cert-dest";

export default {
  name: "UserEdit",
  components: {
    FieldLabelNormal,
  },
  computed: {
    zipcodeFullValidation() {
      return validations.zipcodePart1AndPart2(
        this.certificateForm.zipCdPart1,
        this.certificateForm.zipCdPart2
      );
    },
    deliZipcodeFullValidation() {
      return validations.zipcodePart1AndPart2(
        this.certificateForm.deli_zipCdPart1,
        this.certificateForm.deli_zipCdPart2
      );
    }
  },
  data: () => ({
    // Validations
    valid: true,
    zipcodeValid: true,
    deliZipcodeValid: true,
    menu: false,
    birthDateShow: false,
    cert_regist_dateShow: false,
    cert_expire_dateShow: false,
    cert_update_dateShow: false,
    expflg: true,
    address_info: false,
    image_preview_show_1: false,
    after_image_upload: false,
    dragging: false,
    prefectures: PREFS,
    certificate_destination: CERTDEST,
    activePicker: null,
    date: null,
    previewImage_1: null,
    upload_image_file_name: null,
    upload_image_file_size: null,
    login_user: '',
    certificateForm: {},
    cert_codes: [],
    appli_text: [],
    branches: [],
    companies: [],
    prevZipcode: null,
    prevDeliZipcode: null,
    certpref: null,
    certadd: null,
    delipref: null,
    deliadd: null,
    show_brith_date: null,
    showError: [],
    delicode: DELICODE,
    user_tabs: USERTAB,
    buttonKey: 1,
    // 都道府県
    prefecturesRules: [
    ],
    requiredSelectRules: [
      (v) => validations.requiredSelect(v)
    ],
    requiredRules: [
      (v) => validations.required(v)
    ],
    certNumberRules: [
      (v) => validations.required(v),
      (v) => validations.halfWidthNumber(v)
    ],
    // 所属会社名
    certNameRules: [
      (v) => validations.required(v),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
      (v) => validations.maxLength(v, 50),
    ],
    certNameKanaRules: [
      v => validations.required(v),
      v => validations.fullWithKata(v),
      v => validations.maxLength(v, 50)
    ],
    // 会員住所(住所/マンション名)
    address1Rules: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 50),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
    ],
    address2Rules: [
      (v) => validations.maxLength(v, 50),
      (v) => validations.FullWidthHalfWidthAlphabetNumberAndHalfWidthSpace(v),
    ],
    // 電話番号
    telRules: [v => validations.tel(v)],
    telRules2: [
      (v) => validations.required(v),
      (v) => validations.tel(v)
    ],
    // メールアドレス
    emailRules: [
      (v) => validations.required(v),
      (v) => validations.maxLength(v, 200),
      (v) => validations.email(v),
    ],
    // 住所
    descriptionRules: [
      v => validations.maxLength(v, 1000),
    ]
  }),
  created: async function () {
    await this.refresh();
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  methods: {
    async refresh() {
      this.login_user = JSON.parse(localStorage.getItem('userInfo'));
      this.show_brith_date = moment().subtract(18, 'years').format("YYYY-MM-DD");
      let params = {
        id: this.login_user.id,
        user_code: this.login_user.user_code,
        branch_code: this.login_user.branch_code,
      }
      await getBranch(params).then((response) => {
        this.branches = response.data;
      });
      await getCert().then((response) => {
        this.cert_codes = response.data;
      });
      let param = {
        user_code: this.login_user.user_code,
      }
      await getRequest(param).then((response) => {
        this.appli_text = response.data;
      });
      await getCompany(params).then((response) => {
        this.companies = response.data;
      });
    },
    _ondrop(e) {
      e.preventDefault();
      this.dragging = false;
    },
    _ondragenter(e) {
      e.preventDefault();
      this.dragging = false;
    },
    _ondragleave(e) {
      e.preventDefault();
      this.dragging = false;
    },
    _ondragover(e) {
      e.preventDefault();
      this.dragging = true;
    },
    startDrop(e) {
      e.preventDefault();
      this.inDrop = true;
    },
    endDrop(e) {
      e.preventDefault();
      this.inDrop = false;
    },
    dropThumb(e) {
      e.preventDefault();
      this.imgOnFileChanged(e);
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    selectImageClick() {
      window.addEventListener(
        "focus",
        () => {
          // this.isSelecting_img = false;
        },
        { once: true }
      );
      this.$refs.uploader_img.click();
    },
    imgOnFileChanged(e) {
      this.dragging = false;
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        if (
          files[0].type === "" ||
          !["image/jpeg", "image/jpg"].includes(files[0].type)
        ) {
          this.image_preview_show_1 = false;
          this.certificateForm.appli_image = null;
          this.showError.appli_image = true;
          this.showError.appli_image = ["顔写真はjpegタイプのみ有効です"];
          this.upload_image_file_name = files[0].name;
          this.after_image_upload = false;
          return;
        } else if (Math.ceil((files[0].size / 1024).toFixed(3)) > 3072) {
          this.certificateForm.appli_image = null;
          this.image_preview_show_1 = false;
          this.showError.appli_image = true;
          this.showError.appli_image = ["顔写真は3MB以内のファイルのみ有効です"];
          this.upload_image_file_name = files[0].name;
          this.after_image_upload = false;
        } else {
          this.showError.appli_image = false;
          this.showError.appli_image = [];
          this.upload_image_file_name = files[0].name;
          this.upload_image_file_size =
            Math.ceil((files[0].size / 1024).toFixed(3)) + "KB";
          this.image_preview_show_1 = true;
          let reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage_1 = e.target.result;
          };
          reader.readAsDataURL(files[0]);
          this.$emit("input", files[0]);
          this.certificateForm.appli_image = files[0];
          this.certificateForm.appli_image_name = files[0].name;
          this.after_image_upload = true;
        }
      } else {
        this.image_preview_show_1 = false;
        this.certificateForm.appli_image = null;
        this.showError.appli_image = true;
        this.showError.appli_image = ["顔写真は必要項目です"];
        this.upload_image_file_name = "";
        this.after_image_upload = false;
        this.dragging = false;
      }
    },
    deleteUploadImage() {
      this.upload_image_file_name = null;
      this.upload_image_file_size = null;
      this.previewImage_1 = null;
      this.uploaded_image_info = false;
      this.after_image_upload = false;
      this.$refs.uploader_img.value = null;
      this.image_preview_show_1 = false;
      this.certificateForm.appli_image = null;
    },
    changeBranch() {
      let params = {
        user_code: this.login_user.user_code,
        branch_code: this.certificateForm.branch_code,
        changeflg: true,
      }
      getCompany(params).then((response) => {
        this.companies = response.data;
      });
    },
    setExpiredDate() {
      var current_date = this.certificateForm.cert_regist_date;
      var expired_date = moment(current_date).add(5, 'Y');
      expired_date = moment(expired_date).subtract(1, 'd');
      this.certificateForm.cert_expiry_date = moment(expired_date).format('YYYY-MM-DD');
    },
    punkTextClick() {
      this.$router.push("/user/certificate"); // 管理者のログイン画面に遷移
    },
    validateZipcode() {
      this.$refs.zipcodeForm.validate();
      if (this.zipcodeValid) {
        var newVal = this.certificateForm.zipCdPart1 + this.certificateForm.zipCdPart2;
        if (this.prevZipcode != newVal) {
          new YubinBangoCore(newVal, addr => {
            if (addr.region) {
              this.certpref = addr.region;
              this.certadd = addr.locality + addr.street;
            }
          });
        }
        this.prevZipcode = newVal;
      }
    },
    deliValidateZipcode() {
      this.$refs.delizipcodeForm.validate();
      if (this.deliZipcodeValid) {
        var newVal = this.certificateForm.deli_zipCdPart1 + this.certificateForm.deli_zipCdPart2;
        if (this.prevDeliZipcode != newVal) {
          new YubinBangoCore(newVal, addr => {
            if (addr.region) {
              this.delipref = addr.region;
              this.deliadd = addr.locality + addr.street;
            }
          });
        }
        this.prevDeliZipcode = newVal;
      }
    },
    async add() {
      setTimeout(this.btnReset, 1000);
      await this.$refs.form.validate();
      await this.$refs.zipcodeForm.validate();
      await this.$refs.delizipcodeForm.validate();
      let loginUser = JSON.parse(localStorage.getItem('userInfo'));
      if (!this.valid) {
        let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
        window.scrollTo(
          domRect.left + document.documentElement.scrollLeft,
          domRect.top + document.documentElement.scrollTop
        );
        return;
      }
      // this.certificateForm.cert_prefectures = this.certpref;
      // this.certificateForm.cert_address1 = this.certadd;
      // this.certificateForm.deli_prefectures = this.delipref;
      // this.certificateForm.deli_address1 = this.deliadd;
      this.certificateForm.loginid = loginUser.id;
      var data = this.AppendData();
      await addCertificate(data)
        .then((response) => {
          if (response.message == 'invalidInput') {
            this.showError = response.error;
            let domRect = document.querySelector('.error--text').parentNode.getBoundingClientRect();
            window.scrollTo(
              domRect.left + document.documentElement.scrollLeft,
              domRect.top + document.documentElement.scrollTop
            );
          } else {
            this.showError = [];
            this.$store.commit("SAVE_DIALOG", {
              text: "保存しました",
              icon: "mdi-checkbox-marked-circle-outline",
            });
            this.$router.push("/user/certificate/edit/" + response.data.id);
          }
        }).catch(() => { });
    },
    AppendData: function () {
      var data = new FormData();
      data.append("id", this.certificateForm.id);
      data.append("loginid", this.certificateForm.loginid);
      data.append("cert_code", this.certificateForm.cert_code);
      data.append("cert_regist_date", this.certificateForm.cert_regist_date);
      data.append("cert_expiry_date", this.certificateForm.cert_expiry_date);
      data.append("branch_code", this.certificateForm.branch_code);
      data.append("company_name", this.certificateForm.company_name);
      data.append("cert_name", this.certificateForm.cert_name);
      data.append("cert_kana_name", this.certificateForm.cert_kana_name);
      data.append("zipCdPart1", this.certificateForm.zipCdPart1);
      data.append("zipCdPart2", this.certificateForm.zipCdPart2);
      data.append("cert_prefectures", this.certpref);
      data.append("cert_address1", this.certadd);
      data.append("cert_address2", this.certificateForm.cert_address2);
      if(this.certificateForm.cert_address2) {
        data.append("cert_address2", this.certificateForm.cert_address2);
      }
      if(this.certificateForm.tel) {
        data.append("tel", this.certificateForm.tel);
      }      
      data.append("email", this.certificateForm.email);
      data.append("birthday", this.certificateForm.birthday);
      data.append("appli_image", this.certificateForm.appli_image);
      data.append("appli_image_name", this.certificateForm.appli_image_name);
      data.append("appli_image_size", this.upload_image_file_size);
      if(this.certificateForm.deli_code) {
        data.append("deli_code", this.certificateForm.deli_code);
      }
      if(this.certificateForm.deli_zipCdPart1) {
        data.append("deli_zipCdPart1", this.certificateForm.deli_zipCdPart1);
      }
      if(this.certificateForm.deli_zipCdPart2) {
        data.append("deli_zipCdPart2", this.certificateForm.deli_zipCdPart2);
      }
      if(this.delipref) {
        data.append("deli_prefectures", this.delipref);
      }
      if(this.deliadd) {
        data.append("deli_address1", this.deliadd);
      }
      if(this.certificateForm.deli_address2) {
        data.append("deli_address2", this.certificateForm.deli_address2);
      }
      if(this.certificateForm.deli_tel) {
        data.append("deli_tel", this.certificateForm.deli_tel);
      }
      if(this.certificateForm.national_cert1) {
        data.append("national_cert1", this.certificateForm.national_cert1);
      }
      if(this.certificateForm.national_cert2) {
        data.append("national_cert2", this.certificateForm.national_cert2);
      }
      if(this.certificateForm.description) {
        data.append("description", this.certificateForm.description);
      }
      return data;
    },
    btnReset() {
      this.buttonKey++;
    }
  },
  async mounted() {
    this.login_user = JSON.parse(localStorage.getItem('userInfo'));
    if (this.login_user.user_code == this.user_tabs.UNION_MEMBER) {
      this.$router.push("/401");
    } else {
      const navigationBar = this.$parent.$parent.$parent;
      navigationBar.setFooter(['新規申請フォーム'], '', false);
    }
  }
};
</script>
<style lang="scss" scoped>
.dropZone {
  position: relative;
}
.dropZone:hover {
  background-color: #e2f7fa !important;
}
.dropZone-over {
  background-color: #e2f7fa !important;
  opacity: 0.8;
}
.pickup-title1 {
  margin-top: 30px;
}
.pickup-title2 {
  margin-left: 65px !important;
  margin-top: 5px;
}
.after-pickup-title1 {
  margin-top: 30px;
  text-align: center;
}
.after-pickup-title2 {
  text-align: center;
  margin-top: 5px;
}
.pickup-button {
  width: 150px;
}
.text-sub-title {
  font-size: $size-normal;
  color: $color-title;
  margin-top: 5px;
  padding-left: 7px;
  font-weight: 500 !important;
}
.uploaded-data-title {
  font-size: 16px;
  color: #211917;
}
.btn-text {
  font-size: $size-btn-font;
  font-weight: bold;
}
.btn-margin {
  margin-right: 40px !important;
  background-color: #56b405 !important;
  color: #ffffff !important;
}
.pickup2-mobile {
  margin-top: 10px !important;
  text-align: center;
}
.btn-pickup-margin {
  margin-left: 5px;
  background-color: #40b9b9 !important;
  color: #ffffff !important;
}
.btn-area {
  text-align: left;
}
// .punks-area {
//   width: 100%;
//   align-items: center;
//   background: white;
// }
// .punks-textpointer {
//   color: $user-punk-color;
//   font-size: 13px;
// }
.arrow-icon {
  height: 11px;
}
.sizepos {
  text-align: right;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}
.delete-icon {
  padding-top: 0;
}
.delete-icon:hover::before {
  opacity: 0 !important;
}
.imagePreviewWrapper {
  width: 132px;
  height: 132px;
  display: block;
  cursor: pointer;
  background-size: contain, cover;
  background-position: center center;
}
.trash-icon {
  width: 20px;
  height: 22px;
}
.truncate {
  max-width: 85%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-line-driver {
  color: #1947a3;
  border-color: unset !important;
}
@media (max-width: 768px) {
  .btn-text {
    width: 130px;
  }
}
/* phone size */
@media screen and (max-width: 763px) {
  .container {
    margin-left: 0px !important;
  }
  .common-title {
    display: none;
  }
  .btn-margin {
    margin: 0 auto !important;
  }
  .display-checkbox {
    margin-left: 8px !important;
  }
  .vip-mobile {
    margin-left: 8px !important;
  }
  .image_up {
    flex-wrap: unset !important;
  }
  // .punks-area {
  //   margin-bottom: 4px !important;
  // }
}
/* ipad size */
@media (min-width: 768px) and (max-width: 1023px) {
  .btn-text {
    width: 160px !important;
  }
  .after-pickup-title1 {
    margin-top: 25px !important;
    margin-left: 11px !important;
    text-align: center !important;
  }
  .after-pickup-title2 {
    margin-left: -6px !important;
    margin-top: 5px !important;
    text-align: center !important;
  }
}
@media screen and (max-width: 763px) {
  .admin-user-info .container {
    width: 100% !important;
  }
  .btn-text {
    margin-bottom: 40px !important;
  }
  .upload-box {
    &.thumbnail-upload-box {
      padding-right: 0px;
    }
  }
}
@media screen and (max-width: $size-pc-min) {
  .after-pickup-title1 {
    margin-top: 20px;
    margin-left: 5px;
    text-align: center;
  }
  .after-pickup-title2 {
    text-align: center;
    margin-top: 5px;
  }
  .sizepos {
    text-align: right;
  }
}
@media screen and (max-width: $size-mobile) {
  .sizepos {
    text-align: left;
  }
  .image_up {
    margin-top: 2px;
  }
}
@media (min-width: 1024px) and (max-width: $size-pc-min) {
  .after-pickup-title1 {
    margin-top: 30px;
  }
  .after-pickup-title2 {
    text-align: center;
  }
}
</style>
<style lang="scss">
.user-application-info {
  .input-login {
    .theme--light.v-icon {
      color: $admin-primary;
    }
  }
  .v-sheet.v-card:hover {
    background-color: #e2f7fa;
  }
}
.nationalcertradio {
  width: 150px;
}
.main-title {
  font-size: $size-title;
  color: $user-header-title;
  font-weight: bold;
}
.v-messages__message {
  color: $error-text;
  font-size: 16px;
}
.vcard-upload {
  border: 3px dotted #1947a3 !important;
}
.user-menu .nationalcertradio .primary--text {
  color: #3FB2BC !important;
}
@media screen and (max-width: $size-mobile) {
  .user-application-info {
    overflow: hidden;
    .container {
      padding: 0 !important;
    }
  }
  .btn-area {
    text-align: center !important;
  }
  .pickup-title1 {
    margin-top: 0px !important;
    margin-left: 10px !important;
  }
  .pickup-title2 {
    margin-left: 65px !important;
    margin-top: 5px !important;
  }
  .img-upload-part {
    display: flex !important;
  }
  .after-pickup-title1 {
    margin-left: 0px !important;
    font-size: 11px !important;
    text-align: center !important;
    margin-top: 30px !important;
  }
  .after-pickup-title2 {
    margin-left: 0px !important;
    margin-top: 10px !important;
    font-size: 11px !important;
    text-align: center !important;
  }
  .btn-pickup-font {
    font-size: 14px !important;
  }
  .pickup1-mobile {
    margin-top: 30px !important;
    font-size: 11px !important;
  }
  .pickup2-mobile {
    font-size: 11px !important;
  }
  .v-messages__message {
    font-size: 14px;
  }
  .nationalcertradio {
    width: 124px;
  }
}
@media (min-width: 320px) and (max-width: 375px) {
  .after-pickup-title1 {
    margin-top: 30px !important;
  }
  .pickup-button {
    width: 120px !important;
  }
  .pickup1-mobile {
    margin-top: 20px !important;
    margin-left: 0px !important;
    font-size: 11px !important;
  }
  .btn-pickup-margin {
    margin-left: 0px;
  }
}
</style>
